export default {"src":"/_next/static/media/checkboxIcon.0d7636be.svg","height":20,"width":20};